<p-toast />
<p-confirmDialog />

<div class="px-6 py-4">
  <div class="mb-4">
    <p class="text-xl font-semibold m-0">{{ 'layout.configurations.opportunities.title' | translate }}</p>
    <p class="text-600 mt-2 mb-0">{{ 'layout.configurations.opportunities.description' | translate }}</p>
  </div>

  <div class="opportunity-reference-grid">
    <section class="opportunity-reference-panel" *ngFor="let panel of panels">
      <h2 class="text-lg font-semibold mt-0 mb-3">{{ panel.titleKey | translate }}</h2>

      <div class="flex gap-2 mb-3">
        <input
          pInputText
          class="w-full"
          [(ngModel)]="panel.newValue"
          [placeholder]="'layout.configurations.opportunities.valuePlaceholder' | translate"
          (keyup.enter)="addValue(panel)" />
        <p-button
          icon="pi pi-plus"
          [rounded]="true"
          [disabled]="!panel.newValue.trim() || panel.saving"
          [loading]="panel.saving"
          (onClick)="addValue(panel)"
          [attr.aria-label]="'layout.configurations.opportunities.addValue' | translate" />
      </div>

      <div class="reference-values" *ngIf="!panel.loading; else loadingValues">
        <div class="reference-value" *ngFor="let value of panel.values; trackBy: trackById">
          <span class="text-900">{{ value.label }}</span>
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            size="small"
            (onClick)="confirmDelete($event, panel, value)"
            [attr.aria-label]="'layout.configurations.opportunities.deleteValue' | translate" />
        </div>
        <p class="text-600 text-sm my-3" *ngIf="panel.values.length === 0">
          {{ 'layout.configurations.opportunities.emptyValues' | translate }}
        </p>
      </div>

      <ng-template #loadingValues>
        <p class="text-600 text-sm my-3">{{ 'layout.configurations.opportunities.loading' | translate }}</p>
      </ng-template>
    </section>
  </div>
</div>
